import React, { useState, type ReactElement } from 'react';
import { Box } from '@mui/material';
import MyProfileTabs from '../../components/MyProfile/MyProfileTabs/MyProfileTabs';
import ManageProfile from '../../components/MyProfile/ManageProfile/ManageProfile';
import ChangePin from '../../components/MyProfile/ChangePin/ChangePin'; // Ensure this component exists
import ProfileActiveSvg from '../../assets/img/profile-icon-active.svg';
import ProfileInactiveSvg from '../../assets/img/profile-icon-inactive.svg';
import PinIconActive from '../../assets/img/pin-icon-active.svg';
import PinIconInactive from '../../assets/img/pin-icon-inactive.svg';
import SecurityIconActive from '../../assets/img/security-icon-active.svg';
import SecurityIconInactive from '../../assets/img/security-icon-inactive.svg';
import ChangePassword from '../../components/MyProfile/ChangePassword/ChangePassword';

export default function MyProfile(): ReactElement {
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: 'Profile Details',
      children: <ManageProfile />,
      activeIcon: <Box component="img" src={ProfileActiveSvg} alt="profile-icon-active" />,
      inactiveIcon: <Box component="img" src={ProfileInactiveSvg} alt="profile-icon-inactive" />,
    },
    {
      label: 'KRISTA™/KROMA™ PIN',
      children: <ChangePin />,
      activeIcon: <Box component="img" src={PinIconActive} alt="pin-icon-active" />,
      inactiveIcon: <Box component="img" src={PinIconInactive} alt="pin-icon-inactive" />,
    },
    {
      label: 'Security',
      children: <ChangePassword />,
      activeIcon: <Box component="img" src={SecurityIconActive} alt="security-icon-active" />,
      inactiveIcon: <Box component="img" src={SecurityIconInactive} alt="security-icon-inactive" />,
    },
  ];

  const handleTabChange = (index: number) => {
    setActiveTab(index);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1', minHeight: '90vh' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <MyProfileTabs tabs={tabs} activeTab={activeTab} onChange={handleTabChange} />
      </Box>
    </Box>
  );
}
